import { render, staticRenderFns } from "./member_account_extract_list.vue?vue&type=template&id=2ff1095c&scoped=true"
import script from "./member_account_extract_list.vue?vue&type=script&lang=js"
export * from "./member_account_extract_list.vue?vue&type=script&lang=js"
import style0 from "./member_account_extract_list.vue?vue&type=style&index=0&id=2ff1095c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1095c",
  null
  
)

export default component.exports